import { makeStyles } from "@material-ui/core";

export const costPerMileWidgetStyle = makeStyles((theme) => ({
    tooltip: {
        padding: '0.5em 1em',
        background: '#fff',
        borderRadius: '5px',
        boxShadow: '2px 3px 10px #d7d6d6',
        textAlign: 'center'
    },
    graphTootltip: {
        background: theme.palette.background.paper,
        padding: '0.1px 0.6em',
        boxShadow: theme.shadows[3],
        maxWidth: '9rem'
    },
    graphWrapper: {
        height: '100%',
        minHeight: '20rem'
    },
    label: {
        backgroundColor: 'white'
    },
    filterIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    XAxis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px', /* Adjust width as needed */
        display: 'block',
    },
    dialogTitleWrapper: {
        margin: '1rem 0 0 1rem'
    },
    dialogTitle: {
        fontSize: '1em',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            marginRight: '0.5em'
        },
        marginbottom: '0.5em'
    },
}));